export default function SectionHeader({ label, index, title, children }) {
  return (
    <header className="section-header">
      {(index || label) && (
        <p className="section-header__meta">
          {index && <span className="section-header__index">{index}</span>}
          {label && <span className="section-header__label">{label}</span>}
        </p>
      )}
      <h2 className="section-header__title">{title}</h2>
      {children && <div className="section-header__body">{children}</div>}
    </header>
  );
}
